import {elementsTracking} from '../../../../../viscomjs/analytics/';

const SwitchOnAnalyticEvents = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        elementsTracking.init();

        resolve(doThat);
    });
};

export {SwitchOnAnalyticEvents};
